export default __webpack_public_path__ + "static/media/item_4@3x.d0e427ba.png";